import apiInstance from '@apis/index';
import { IMediaQuery } from 'interface/medias';

export enum MediaPath {
  DEFAULT = '/medias',
  DETAIL = '/medias/:id',
  LIKE = '/medias/:id/like',
  VIEW = '/medias/:id/view',
}

export const getMediaList = async (payload: IMediaQuery) => {
  return apiInstance.get(MediaPath.DEFAULT, {
    params: {
      ...payload,
    },
  });
};

export const getMediaDetail = async (id: string) => {
  return apiInstance.get(MediaPath.DETAIL.replace(':id', id));
};

export const likeMedia = async (id: string) => {
  return apiInstance.post(MediaPath.LIKE.replace(':id', id), null);
};

export const unlikeMedia = async (id: string) => {
  return apiInstance.delete(MediaPath.LIKE.replace(':id', id));
};

export const viewMedia = async (id: string) => {
  return apiInstance.post(MediaPath.VIEW.replace(':id', id), null);
};
